import * as React from 'react';
import Paper from '@mui/material/Paper';

export default function renderSuggestionsContainer(options) {
  const { containerProps, children } = options;

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  );
}